import VisibleLib from './jquery.visible';

jQuery(document).ready(function($) {
  $('.banner-cross').click(function(e) {
    $('.information-bar-wrapper').hide();
  });

  // $(window).scroll(function() {
  //   if ($('.section-related').visible(true)) {
  //     $('.information-bar-wrapper').css('opacity','0');
  //   }else{
  //     $('.information-bar-wrapper').css('opacity','1');
  //   }
  // });
});
